<script>
  import { fade } from 'svelte/transition';

  import Alert from '@components/Alert.svelte';
  import Checkbox from '@components/Checkbox.svelte';
  import { getGroupStore } from '@stores/group';

  let commentStore = getGroupStore('commentStore');
  import { getGlobalStore } from '@stores/global';

  let reportContentStore = getGlobalStore('reportContentStore');

  export let mobile = false;
  export let comment;
  export let handleDelete;
  export let currentUserComment;
  export let isOwner;
  export let context;

  let spamChecked = false;

  let handleClose = function () {
    showOptions = false;
  };

  let handleShow = function () {
    showOptions = true;
  };

  let showOptions = false;
  let showCancelChangesDialog = false;
</script>

<style style="text/scss" lang="scss">
  .tile {
    color: black;
    position: relative;
    cursor: pointer;
    border-radius: 15px;
    justify-content: space-between;
    flex-direction: column;
    display: flex;
    background: #fff;
    width: 100%;
    box-shadow: 0 12px 64px -20px rgba(0, 0, 0, 0.2);
    padding: 10px;
    padding-left: 15px;
    padding-right: 15px;
    border: 2px solid transparent;
    transition: 0.25s;
    height: 240px;

    &:hover {
      box-shadow: 0 1.375rem 6.25rem rgba(0, 0, 0, 0.18);
    }

    .top-bar {
      display: flex;
      justify-content: space-between;
      position: relative;

      .back-btn {
        position: absolute;
        right: 0px;
        top: -12px;
        padding: 10px;
        padding-right: 0px;
        background: transparent;
        border: none;
        cursor: pointer;
        display: inline-block;

        &:hover {
          path {
            stroke: #a893f9;
          }
        }
      }
    }

    &.tile-options-menu {
      cursor: unset;
      z-index: 100;
      position: absolute;
      width: calc(100% + 30px);
      min-height: 80px;
      height: min-content;
      margin-top: -10px;
      margin-left: -15px;
    }
  }

  .menu-options {
    display: flex;
    flex-direction: column;
    padding: 10px;
    height: 100%;

    .menu-options-delete {
      padding-top: 5px;
      a {
        font-weight: 500;
        color: #ff5567;

        &:hover {
          color: #99333d;
        }
      }
    }
  }

  .mobile {
    box-shadow: 0 6px 32px -10px rgba(0, 0, 0, 0.2);

    &:hover {
      box-shadow: 0 6px 32px -10px rgba(0, 0, 0, 0.3);
    }
  }

  .tile-options {
    display: flex;
    transition: 0.25s;

    .tile-menu {
      height: 20px;

      display: inline-block;
      background: transparent;
      border: none;
      cursor: pointer;

      &:hover {
        path {
          fill: #a893f9 !important;
        }
      }

      path {
        fill: rgb(213, 207, 234);
      }
    }
  }

  * :global(.comment-delete-question) {
    font-weight: 500;
    font-size: 16px;
  }

  .backdrop {
    width: 100vw;
    height: 100vh;
  }
</style>

<Alert
  mobile={mobile}
  on:yes-click={() => {
    handleClose();
    handleDelete(spamChecked);
  }}
  on:cancel={() => {
    handleClose();
  }}
  yesButtonText="Delete"
  objectText={null}
  bind:show={showCancelChangesDialog}>
  <div slot="content" class="comment-delete-alert-content">
    <div class="comment-delete-question alert-question">Are you sure you want to delete this?</div>
  </div>
  <div slot="extra_action">
    {#if !currentUserComment}
      <div class="comment-delete-spam-checkbox">
        <Checkbox
          checked={spamChecked}
          label={'Report as spam'}
          on:change={() => {
            spamChecked = !spamChecked;
          }} />
      </div>
    {/if}
  </div>
</Alert>
{#if showOptions}
  <div class="backdrop" on:click|preventDefault|stopPropagation={handleClose} in:fade={{ duration: 100 }} />
  <div class="tile tile-options-menu" class:mobile={mobile} on:click|stopPropagation>
    <div class="top-bar" in:fade={{ duration: 100 }}>
      <button class="back-btn" on:click|preventDefault|stopPropagation={handleClose}>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
            <rect width="12" height="12" fill="white" />
          </mask>
          <g mask="url(#mask0)">
            <path
              d="M7.14978 6.08842C7.13814 6.07681 7.1289 6.06302 7.1226
              6.04783C7.1163 6.03265 7.11305 6.01637 7.11305 5.99993C7.11305
              5.98349 7.1163 5.96721 7.1226 5.95202C7.1289 5.93683 7.13814
              5.92304 7.14978 5.91143L11.7811 1.28062C11.9217 1.13979 12.0006
              0.948872 12.0005 0.749857C12.0004 0.550842 11.9212 0.360034
              11.7803 0.219408C11.6395 0.0787831 11.4486 -0.000140457 11.2496
              1.87653e-07C11.0506 0.000140832 10.8598 0.0793341 10.7191
              0.220158L6.08832 4.84897C6.07671 4.86061 6.06292 4.86985 6.04773
              4.87615C6.03254 4.88245 6.01626 4.8857 5.99982 4.8857C5.98338
              4.8857 5.9671 4.88245 5.95192 4.87615C5.93673 4.86985 5.92294
              4.86061 5.91133 4.84897L1.28051 0.220158C1.21088 0.150495 1.12821
              0.0952284 1.03722 0.0575143C0.946233 0.0198001 0.848706
              0.000376929 0.75021 0.000353716C0.551289 0.000306834 0.360496
              0.079283 0.219805 0.219908C0.079113 0.360534 4.69031e-05 0.551289
              2.08609e-08 0.75021C-4.68614e-05 0.949132 0.0789293 1.13992
              0.219555 1.28062L4.84987 5.91143C4.86151 5.92304 4.87074 5.93683
              4.87705 5.95202C4.88335 5.96721 4.88659 5.98349 4.88659
              5.99993C4.88659 6.01637 4.88335 6.03265 4.87705 6.04783C4.87074
              6.06302 4.86151 6.07681 4.84987 6.08842L0.219555 10.7197C0.149924
              10.7894 0.0946965 10.8721 0.0570253 10.9631C0.019354 11.0541
              -2.31929e-05 11.1516 2.08609e-08 11.2501C4.69031e-05 11.4491
              0.079113 11.6398 0.219805 11.7804C0.289468 11.8501 0.372164
              11.9053 0.463171 11.943C0.554179 11.9806 0.651715 12 0.75021
              12C0.949132 12 1.13989 11.9209 1.28051 11.7802L5.91133
              7.14888C5.92294 7.13724 5.93673 7.12801 5.95192 7.1217C5.9671
              7.1154 5.98338 7.11216 5.99982 7.11216C6.01626 7.11216 6.03254
              7.1154 6.04773 7.1217C6.06292 7.12801 6.07671 7.13724 6.08832
              7.14888L10.7191 11.7802C10.8598 11.9209 11.0505 12 11.2494
              12C11.4484 12 11.6391 11.9211 11.7798 11.7804C11.9205 11.6398
              11.9996 11.4491 11.9996 11.2501C11.9997 11.0512 11.9207 10.8604
              11.7801 10.7197L7.14978 6.08842Z"
              fill="black" />
          </g>
        </svg>
      </button>
    </div>

    <div class="menu-options">
      {#if currentUserComment}
        <div class="menu-options-edit">
          <a
            href="#"
            on:click|preventDefault|stopPropagation={() => {
              commentStore.set({ edit: true, comment: comment, context: context });
              handleClose();
            }}>
            Edit
          </a>
        </div>
      {:else}
        <div class="menu-options-edit">
          <a
            href="#"
            on:click|preventDefault|stopPropagation={() => {
              reportContentStore.set({
                show: true,
                params: { comment_id: comment.id },
                owner: comment.user,
              });
              handleClose();
            }}>
            Report
          </a>
        </div>
      {/if}
      {#if isOwner || currentUserComment}
        <div class="menu-options-delete">
          <a
            href="#"
            on:click|preventDefault|stopPropagation={() => {
              showCancelChangesDialog = true;
              handleClose();
            }}>
            Delete
          </a>
        </div>
      {/if}
    </div>
  </div>
{/if}
<div class="tile-options">
  <div class="tile-menu undraggable" on:click|preventDefault|stopPropagation={handleShow}>
    {#if mobile}
      <img alt="dot-menu" src="/images/profile/horizontal-dots.svg" />
    {:else}
      <svg width="20" height="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <mask id="a" x="0" y="0" width="20" height="20" mask-type="alpha" maskUnits="userSpaceOnUse">
          <rect width="20" height="20" fill="#fff" />
        </mask>
        <g mask="url(#a)">
          <path
            d="m2.5 12.5c-1.3807 0-2.5-1.1193-2.5-2.5-6.0353e-8 -1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5c0 1.3807-1.1193 2.5-2.5 2.5zm15 0c-1.3807 0-2.5-1.1193-2.5-2.5 0-1.3807 1.1193-2.5 2.5-2.5s2.5 1.1193 2.5 2.5c0 1.3807-1.1193 2.5-2.5 2.5zm-10-2.5c0 1.3807 1.1193 2.5 2.5 2.5 1.3807 0 2.5-1.1193 2.5-2.5 0-1.3807-1.1193-2.5-2.5-2.5-1.3807 0-2.5 1.1193-2.5 2.5z"
            clip-rule="evenodd"
            fill="#EAE4FF"
            fill-rule="evenodd" />
        </g>
      </svg>
    {/if}
  </div>
</div>
